import styled from "styled-components";

export const FormGroup = styled.fieldset`
    margin-bottom: 1rem;
    border: none;
    padding: 0;
`;

export const FormFooter = styled.fieldset`
    border: none;
    padding: 0;
    display: flex;
    justify-content: center;
    gap: 1em;
`;
